import { ReactElement, useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

import { Button, Stack } from "@mui/material";

import ConfirmationButton from "../components/shared/ConfirmationButton";
import PageContainer from "../components/shared/PageContainer";
import TemplateForm from "../components/template/TemplateForm";
import * as Objects from "../services/api";
import { Templates } from "../services/api";
import { DefaultSetID } from "../services/api/TemplateSets";

function TemplateEdit() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [template, setTemplate] = useState<Objects.Template>(
    new Objects.Template({ ...(state?.template ?? {}) }),
  );
  const [templateSets, setTemplateSets] = useState<Objects.TemplateSetAggregate[]>([]);

  useEffect(() => {
    Objects.TemplateSets.list().then(setTemplateSets);
  }, [setTemplateSets]);

  if (!state?.template) {
    return <Navigate to="/templates" />;
  }

  const handleUpdate = async () => {
    // Showing the default set is just for visuals, and since the backend doesn’t want the client to send it, we’re removing it before the request goes out
    const templateWithoutDefaultSet = new Objects.Template({
      ...template,
      set_ids: template.set_ids.filter((id) => id !== DefaultSetID),
    });
    try {
      await templateWithoutDefaultSet.update();
      navigate("/templates");
    } catch (error) {
      // handled by EventListener
    }
  };

  const handleDelete = async () => {
    try {
      await Templates.delete(template.name);
      navigate("/templates");
    } catch (error) {
      // handled by EventListener
    }
  };

  const renderActionButtons = (): ReactElement => {
    const hasError = template.hasErrors(template.validate());
    return (
      <Stack direction="row" spacing={1}>
        <Button
          sx={{ marginRight: "7pt", marginTop: "10pt" }}
          onClick={handleUpdate}
          variant="contained"
          disabled={hasError}
        >
          Update
        </Button>
        <ConfirmationButton
          sx={{ marginTop: "10pt" }}
          onConfirm={handleDelete}
          variant="contained"
          dialogTitle="Confirm Deletion"
          dialogMessage={`Are you sure you want to delete "${template.name}"?`}
        >
          Delete
        </ConfirmationButton>
      </Stack>
    );
  };

  return (
    <PageContainer>
      <TemplateForm
        actionButtons={renderActionButtons()}
        template={template}
        setTemplate={setTemplate}
        templateSets={templateSets}
      ></TemplateForm>
    </PageContainer>
  );
}

export default TemplateEdit;
